'use client'

import { cn } from '@src/utils/tailwind'

interface EarnedRibbonProps {
  earnedCount: number
  status?: GamificationApi.BadgeStatus
  className?: string
  isBrightColor?: boolean
}

export function EarnedRibbon({ earnedCount, status, isBrightColor, className }: EarnedRibbonProps) {
  if (earnedCount <= 1) return null

  const isLockedBadge = status === 'active' || status === 'available'

  return (
    <span
      className={cn(
        'inline-flex h-7 items-center justify-center overflow-hidden rounded bg-bodi-accent-deep-500 px-2.5 py-[5px] text-body-base leading-[18px] font-semibold text-bodi-white in-[.bodi-blue]:bg-bodi-accent-deep-500 in-[.bodi-blue]:text-bodi-white',
        { 'bg-bodi-gray-dark text-white': isLockedBadge },
        {
          'text-bodi-black-text bg-bodi-accent-bright-500 in-[.bodi-blue]:bg-bodi-accent-bright-500 in-[.bodi-blue]:text-bodi-black-text':
            isBrightColor,
        },
        className
      )}
    >
      x{earnedCount}
    </span>
  )
}
